import type { RichTextDoc, RichTextNode } from '@org/model';

export function extractPlainText(doc: RichTextDoc | null | undefined): string {
  if (!doc || !Array.isArray(doc.content)) return '';
  return walk(doc.content).replace(/\s+/g, ' ').trim();
}

function walk(nodes: RichTextNode[]): string {
  return nodes.map(nodeToText).join('');
}

function nodeToText(node: RichTextNode): string {
  if (node.type === 'text') return node.text ?? '';
  if (node.type === 'mention') {
    const label = (node.attrs?.label as string | undefined) ?? '';
    return `@${label}`;
  }
  if (node.type === 'emoji') {
    return (node.attrs?.unicode as string | undefined) ?? '';
  }
  if (node.type === 'hardBreak') return '\n';
  if (node.type === 'paragraph' || node.type === 'heading' || node.type === 'blockquote' || node.type === 'codeBlock') {
    return (node.content ? walk(node.content) : '') + '\n';
  }
  if (node.type === 'bulletList' || node.type === 'orderedList') {
    return node.content ? walk(node.content) : '';
  }
  if (node.type === 'listItem') {
    return '• ' + (node.content ? walk(node.content) : '') + '\n';
  }
  return node.content ? walk(node.content) : '';
}
